// J-320 (Louis, 2026-10-23): Gap Workbook Uploads, one page with two variants. An uploader (`acoGapUploads.upload`:
// analyst, practice manager, practice staff, group logins) uploads and sees only their own uploads; the admin
// (`acoGapUploads.readAll`) sees every user's and downloads them. Both need PHI access, as every one of the
// routes does. Any other account reads why the page is not theirs; the server refuses it either way (403).
// The page serves a group or practice user (`ownScope`): its reads are the caller's own uploads.
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { AlertBanner } from "@vbltc/ui/components/alert-banner/alert-banner";

import { ShellLoading } from "@/features/aco-shell/components/shell-loading";
import { meAccessQueryOptions } from "@/features/auth/api/me-access";
import { usePermission } from "@/features/auth/use-permission";
import { AllUploadsScreen } from "@/features/gap-workbook-uploads/components/all-uploads-screen";
import { MyUploadsScreen } from "@/features/gap-workbook-uploads/components/my-uploads-screen";

export const Route = createFileRoute("/_authenticated/gap-workbook-uploads")({
  staticData: { screenName: "Gap Workbook Uploads", ownScope: true },
  component: GapWorkbookUploadsPage,
});

function GapWorkbookUploadsPage() {
  const uploader = usePermission({ acoGapUploads: ["upload"] });
  const admin = usePermission({ acoGapUploads: ["readAll"] });
  const access = useQuery(meAccessQueryOptions());
  if (!uploader && !admin) return <NotAvailable />;
  if (access.isPending) return <ShellLoading />;
  if (access.data?.phiAccess !== true) return <NotAvailable />;
  return uploader ? <MyUploadsScreen /> : <AllUploadsScreen />;
}

function NotAvailable() {
  return (
    <div data-testid="gap-uploads-no-access">
      <AlertBanner variant="info" title="Gap Workbook Uploads is not available to you">
        It is for the users who download the Gap Closure Workbook and have PHI access, and for the
        admin. An admin sets each user&apos;s role and PHI access on Users &amp; Access.
      </AlertBanner>
    </div>
  );
}
